import ConnectedAccount from './ConnectedAccount';

export default ConnectedAccount;
